export default "__VITE_ASSET__CXUDyW6j__"